<!--TODO Can And Should be simplified as to have a single label field rendered and then perform ui logic from CSS -->
<label [for]="id" *ngIf="leftLabel">{{ label }}</label>
<div class="input-field float-input"
     [class.ui-float-label]="floatLabel"
     [class.invalid]="hasError">
    <label *ngIf="topLabel" [for]="id" class="active">{{ label }}</label>
    <p-calendar
        [placeholder]="determinePlaceholder"
        [dateFormat]="displayDateFormat"
        [appendTo]="appendTo"
        [showTime]="showTime"
        [hourFormat]="hourFormat"
        showClear="true"
        [selectionMode]="selectionMode"
        (onClear)="clear()"
        (onSelect)="onSelect($event)"
        [(ngModel)]="value">
        <i class="material-icons">assignment_ind</i>
    </p-calendar>
    <label *ngIf="floatLabel" [for]="id" class="active">{{ label }}</label>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors"></app-form-error-list>
</div>

